import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ClientInfo} from '../model/client-info';

@Injectable()
export class ClientService {

  constructor(public _http: HttpClient) { }


  /**
   * Get a list of all available client names
   * @returns {Observable<string[]>}
   */
  public getClients(): Observable<string[]> {
    return new Observable<string[]>((subscriber: Subscriber<string[]>) => {
      this._http.get(environment.endpoints.clientBaseUrl + environment.endpoints.clientList)
        .subscribe(
          (clients: string[]) => {
            subscriber.next(clients);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          });
    });
  }

  /**
   * Get the Client Name from the Client
   * @returns (Observable<string[]>)
   */
  public getClientMeta(): Observable<ClientInfo> {
    return new Observable<ClientInfo>((subscriber: Subscriber<ClientInfo>) => {
      this._http.get<ClientInfo>(environment.endpoints.clientBaseUrl + environment.endpoints.getClientInfo)
        .subscribe(
          (response: ClientInfo) => {
            subscriber.next(response);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          });
    });
  }

  /**
   * Get a list of all available database schemas
   * @returns {Observable<string[]>}
   */
  public getDbSchemas(): Observable<string[]> {
    return new Observable<string[]>((subscriber: Subscriber<string[]>) => {
      this._http.get(environment.endpoints.clientBaseUrl + environment.endpoints.dbSchemas)
        .subscribe(
          (schemas: string[]) => {
            subscriber.next(schemas);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  /**
   * Get a list of all available execution properties
   * @returns {Observable<string[]>}
   */
  public getExecutionProperties(): Observable<string[]> {
    return new Observable<string[]>((subscriber: Subscriber<string[]>) => {
      this._http.get(environment.endpoints.clientBaseUrl + environment.endpoints.executionProperties)
        .subscribe(
          (executionProperties: string[]) => {
            subscriber.next(executionProperties);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  /**
   * Get a list of all log message severities
   * @returns {Observable<string[]>}
   */
  getSeverities(): Observable<string[]> {
    return new Observable<string[]>((subscriber: Subscriber<string[]>) => {
      this._http.get(environment.endpoints.clientBaseUrl + environment.endpoints.severityList)
        .subscribe(
          (priorities: string[]) => {
            subscriber.next(priorities);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  /**
   * Get a list of all workflow types
   * @returns {Observable<string[]>}
   */
  getWorkflowTypes(): Observable<string[]> {
    return new Observable<string[]>((subscriber: Subscriber<string[]>) => {
      this._http.get(environment.endpoints.clientBaseUrl + environment.endpoints.workflowTypeList)
        .subscribe(
          (priorities: string[]) => {
            subscriber.next(priorities);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

}
